import type { CSSProperties, FC } from 'react'

import { cn } from '@/lib/utils'
import { hand } from '@/lib/fonts'
import { Photo } from '@/components/kit/photo'
import { Reveal } from '@/components/kit/reveal'
import { SectionLabel } from '@/components/kit/section-label'
import { SplitText } from '@/components/kit/split-text'
import { studioMoments } from '@/constants/home'

export const BehindTheScenes: FC = () => {
    return (
        <section
            id='behind-the-scenes'
            aria-labelledby='bts-title'
            className='overflow-hidden py-20 md:py-28'
        >
            <div className='mx-auto max-w-[1400px] px-5 md:px-10'>
                <div className='grid gap-8 lg:grid-cols-12 lg:items-end'>
                    <div className='lg:col-span-7'>
                        <SectionLabel index='15'>Behind the scenes</SectionLabel>
                        <SplitText
                            as='h2'
                            id='bts-title'
                            lines={['The reel nobody', 'asked for']}
                            italic='nobody'
                            className='mt-5 text-[clamp(2.75rem,5.6vw,5.25rem)] font-bold leading-[0.9] tracking-[-0.045em]'
                        />
                    </div>
                    <Reveal
                        as='p'
                        delay={150}
                        className='text-lg leading-relaxed text-stone lg:col-span-5'
                    >
                        Candid moments from the studio: whiteboards, shoot days, the coffee station and the calendar wall that runs our lives. Hover to pause.
                    </Reveal>
                </div>
            </div>

            <div className='ticker mt-14'>
                <ul
                    className='ticker-track flex w-max items-start gap-8 px-4 py-6'
                    style={{ '--ticker-duration': '75s' } as CSSProperties}
                >
                    {[...studioMoments, ...studioMoments].map((moment, index) => (
                        <li
                            key={`${moment.caption}-${index}`}
                            aria-hidden={index >= studioMoments.length}
                            className='w-[230px] shrink-0 md:w-[270px]'
                            style={{ rotate: `${moment.rotate}deg`, marginTop: `${(index % 3) * 18}px` }}
                        >
                            <figure className='relative bg-paper p-3 pb-14 shadow-[0_24px_40px_-24px_rgb(30_30_30/0.55)] transition-transform duration-500 ease-expo hover:-translate-y-2 hover:rotate-0'>
                                <span
                                    aria-hidden='true'
                                    className={cn('tape -top-3 left-1/2 -translate-x-1/2', index % 2 === 0 ? 'rotate-3' : '-rotate-6')}
                                />
                                <Photo
                                    src={moment.src}
                                    alt={moment.caption}
                                    sizes='270px'
                                    position={moment.position}
                                    className='halftone aspect-[4/5] w-full'
                                />
                                <figcaption className={cn(hand.className, 'absolute inset-x-3 bottom-3 text-center text-[1.45rem] leading-none text-ink')}>
                                    {moment.caption}
                                </figcaption>
                            </figure>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
